import React from 'react'

const ViewBarArrowUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path d="M20.5 5.8L15 .3c-.4-.4-1.2-.4-1.6 0L7.9 5.8c-.2.2-.4.5-.4.8 0 .3.1.6.3.8.4.4 1.2.4 1.6 0L13 3.9v23.3c0 .6.5 1.1 1.2 1.1.6 0 1.1-.5 1.1-1.1V3.9l3.5 3.5c.4.4 1.2.4 1.6 0 .2-.2.3-.5.3-.8.1-.3 0-.6-.2-.8z" />
  </svg>
)

export default ViewBarArrowUp
